import { createSlice } from '@reduxjs/toolkit';

import { getExternalInfos } from '@/domain/external/actions/get-external-infos.action';

import { ExternalInfos } from './entities/external.entity';

export type ExternalState = {
  infos: ExternalInfos;
};

const initialState: ExternalState = {
  infos: {
    id: -1,
    code: '',
    sector: '',
    scope: '',
    expirationDate: null,
    eventPosition: undefined,
    title: '',
    completion: 0,
    status: '',
    isValidated: false,
    projectId: 0,
    projectInfos: {
      name: '',
      location: '',
      image: '',
      startDate: null,
      endDate: null,
    },
    userName: '',
  },
};

export const externalSlice = createSlice({
  name: 'external',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getExternalInfos.fulfilled, (state, action) => {
      state.infos = action.payload;
    });
  },
});
